// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';
import { Integrations } from '@sentry/tracing';
import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();
/*console.log('(sentry.client.config) publicRuntimeConfig', publicRuntimeConfig);*/
const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;
const CONFIG_ENV = publicRuntimeConfig.CONFIG_ENV || process.env.NODE_ENV;

Sentry.init({
  dsn: SENTRY_DSN || 'https://ac76b9c816f94c69ba26a8a3de989836@sentry.thaicyber.dev/11',
  environment: CONFIG_ENV,
  tracesSampleRate: 1.0,
  autoSessionTracking: true,
  integrations: [new Integrations.BrowserTracing()],
  ignoreErrors: [
    /NetworkError when attempting to fetch resource/,
    /The operation is not supported/,
    /The request is not allowed by the user agent or the platform in the current context/,
    /An event processor returned null/,
  ],
  // debug: true,
});
